import React, {Component} from 'react';
import {Form, Input} from 'semantic-ui-react';

class TasksParts extends Component {
  render() {
    const {
      task1 = '',
      task2 = '',
      task31 = '',
      task32 = '',
      task33 = '',
      task34 = '',
      task35 = '',
      task36 = '',
      task37 = '',
      disabledBtns,
      handleChange,
    } = this.props;

    return (
      <>
        <Form.Group widths='seven'>
          <Form.Field
            control={Input}
            label='Tarea 1'
            placeholder='Tarea 1'
            value={task1}
            maxLength='10'
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task1', value)}
          />
          <Form.Field
            control={Input}
            label='Tarea 2'
            placeholder='Tarea 2'
            value={task2}
            maxLength='10'
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task2', value)}
          />
        </Form.Group>
        <Form.Group widths='seven'>
          <Form.Field
            control={Input}
            label='Tarea 3 - 1'
            placeholder='Tarea 3 - 1'
            value={task31 || ''}
            maxLength='10'
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task31', value)}
          />
          <Form.Field
            control={Input}
            label='Tarea 3 - 2'
            maxLength='10'
            placeholder='Tarea 3 - 2'
            value={task32 || ''}
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task32', value)}
          />
          <Form.Field
            control={Input}
            label='Tarea 3 - 3'
            maxLength='10'
            placeholder='Tarea 3 - 3'
            value={task33 || ''}
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task33', value)}
          />
          <Form.Field
            control={Input}
            label='Tarea 3 - 4'
            maxLength='10'
            placeholder='Tarea 3 - 4'
            value={task34 || ''}
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task34', value)}
          />
          <Form.Field
            control={Input}
            label='Tarea 3 - 5'
            maxLength='10'
            placeholder='Tarea 3 - 5'
            value={task35 || ''}
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task35', value)}
          />
          <Form.Field
            control={Input}
            label='Tarea 3 - 6'
            maxLength='10'
            placeholder='Tarea 3 - 6'
            value={task36 || ''}
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task36', value)}
          />
          <Form.Field
            control={Input}
            label='Tarea 3 - 7'
            maxLength='10'
            placeholder='Tarea 3 - 7'
            value={task37 || ''}
            disabled={disabledBtns}
            onChange={(e, {value}) => handleChange('task37', value)}
          />
        </Form.Group>
      </>
    );
  }
}

export default TasksParts;
